(function () {
  var STORAGE_KEY = 'dk_visibility_route';
  var BOOKING_URL = 'https://calendly.com/deanokeating-1/website-package-call-with-dean';
  var TRAINING_URL = '/pages/ai-business-training';

  function successRoute() {
    var success = document.querySelector('#apply .vis-success');
    if (!success) return false;

    var route = sessionStorage.getItem(STORAGE_KEY);
    success.dataset.qualificationRoute = route || 'review';

    if (route === 'qualified') {
      success.innerHTML =
        '<span class="dk-kicker">You look like a potential fit</span>' +
        '<h3>Your next step is to book a suitability call.</h3>' +
        '<p>Choose a convenient time with Dean. We will use your application to discuss your business, the proposed scope and whether the system is right for you.</p>' +
        '<a class="dk-button" href="#vis-booking">Choose a time below ↗</a>';
    } else {
      var calendar = document.getElementById('vis-booking');
      if (calendar) calendar.hidden = true;
      success.innerHTML =
        '<span class="dk-kicker">A better starting point</span>' +
        '<h3>The done-for-you system may not be the right fit for you yet.</h3>' +
        '<p>You can still learn how to put AI to work in your business. The £97 self-serve Google + AI Visibility Playbook is being prepared, and you can register interest in live AI business training now.</p>' +
        '<a class="dk-button" href="' + TRAINING_URL + '">Explore live AI training ↗</a>';
    }
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  if (successRoute()) return;

  var form = document.getElementById('visibility-application');
  if (!form) return;

  var fields = form.querySelector('.vis-fields');
  if (!fields) return;

  fields.innerHTML =
    '<div class="vis-field"><label for="vis-name">Full name</label><input id="vis-name" name="contact[name]" type="text" autocomplete="name" required></div>' +
    '<div class="vis-field"><label for="vis-business">Business name</label><input id="vis-business" name="contact[Business name]" type="text" autocomplete="organization" required></div>' +
    '<div class="vis-field"><label for="vis-email">Email</label><input id="vis-email" name="contact[email]" type="email" autocomplete="email" required></div>' +
    '<div class="vis-field"><label for="vis-phone">Telephone</label><input id="vis-phone" name="contact[phone]" type="tel" autocomplete="tel" required></div>' +
    '<div class="vis-field"><label for="vis-website">Current website <span class="vis-optional">(optional)</span></label><input id="vis-website" name="contact[Website]" type="url" inputmode="url" placeholder="https://"></div>' +
    '<div class="vis-field"><label for="vis-type">Business type</label><select id="vis-type" name="contact[Business type]" required><option value="">Choose one</option><option value="UK trade or local-service business">UK trade or local-service business</option><option value="Professional service business">Professional service business</option><option value="Ecommerce or online business">Ecommerce or online business</option><option value="Pre-launch or not yet trading">Pre-launch or not yet trading</option><option value="Other">Other</option></select></div>' +
    '<div class="vis-field"><label for="vis-trading">Is the business currently trading?</label><select id="vis-trading" name="contact[Currently trading]" required><option value="">Choose one</option><option value="Yes">Yes</option><option value="No">No</option></select></div>' +
    '<div class="vis-field"><label for="vis-capacity">Can you currently handle more enquiries?</label><select id="vis-capacity" name="contact[Capacity]" required><option value="">Choose one</option><option value="Yes">Yes</option><option value="Not yet">Not yet</option></select></div>' +
    '<div class="vis-field vis-wide"><label for="vis-goal">What would you most like to improve?</label><textarea id="vis-goal" name="contact[Desired outcome]" required></textarea></div>';

  var routeInput = document.createElement('input');
  routeInput.type = 'hidden';
  routeInput.name = 'contact[Qualification route]';
  form.appendChild(routeInput);

  form.addEventListener('submit', function () {
    var type = document.getElementById('vis-type').value;
    var trading = document.getElementById('vis-trading').value;
    var capacity = document.getElementById('vis-capacity').value;
    var investment = form.querySelector('input[name="contact[Investment understood]"]');
    var decisionMaker = form.querySelector('input[name="contact[Decision maker]"]');
    var qualified =
      type === 'UK trade or local-service business' &&
      trading === 'Yes' &&
      capacity === 'Yes' &&
      investment && investment.checked &&
      decisionMaker && decisionMaker.checked;

    var route = qualified ? 'qualified' : 'self-serve';
    routeInput.value = route;
    sessionStorage.setItem(STORAGE_KEY, route);
  });
})();
